"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NoResults;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _searchTermsList = _interopRequireDefault(require("./search-terms-list"));
var _searchBanner = _interopRequireDefault(require("./search-banner"));
var _siteSearchContext = require("./site-search-context");
var _serpSpin = _interopRequireDefault(require("./serp-results/serp-spin"));
var _text = _interopRequireDefault(require("@ux/text"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const NoResultsContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "NoResultsContainer",
  class: "pl-niqhcgn"
});
const DividerLine = /*#__PURE__*/(0, _react2.styled)("hr")({
  name: "DividerLine",
  class: "pl-d796754"
});

/**
 * No Results Component
 * @module NoResults
 *
 * @param {Object} props React props
 * @param {String} props.headline Headline
 * @returns {React.ReactElement} No Results Component
 * @public
 */
function NoResults({
  headline
}) {
  const {
    activeFilter,
    results,
    searchBanner,
    currentDomainSearch,
    setCurrentDomainSearch,
    searchSerp,
    searchData,
    searchValue,
    trackingCustomProperties
  } = (0, _react.useContext)(_siteSearchContext.SiteSearchContext);
  const trackingAttributes = _patternLibraryUtils.tracking.create(`sitesearch_noresults`, false, false, trackingCustomProperties);
  (0, _react.useEffect)(() => {
    searchSerp && setCurrentDomainSearch(searchSerp);
  }, [searchSerp, setCurrentDomainSearch]);
  const {
    hasSpins,
    error
  } = searchData[searchValue] || {};
  const hasSerp = !!currentDomainSearch && (hasSpins || error);
  const banner = !currentDomainSearch && searchBanner && /*#__PURE__*/_react.default.createElement(_searchBanner.default, {
    dataCy: 'search-banner'
  });
  const activeFilterSet = activeFilter === 'all' || !results;
  return /*#__PURE__*/_react.default.createElement(NoResultsContainer, (0, _extends2.default)({
    "data-cy": "no-results"
  }, trackingAttributes), activeFilterSet && banner, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    "data-cy": "no-found-text",
    text: headline,
    as: "paragraph",
    size: 3
  }), hasSerp && /*#__PURE__*/_react.default.createElement(_serpSpin.default, null), !activeFilterSet && banner, /*#__PURE__*/_react.default.createElement(DividerLine, null), /*#__PURE__*/_react.default.createElement(_searchTermsList.default, {
    step: "noresults"
  }));
}
NoResults.propTypes = {
  headline: _propTypes.default.string
};